import { NotificationTypes, SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';
import { PreferredView } from '@/modules/user/types';

export const updatePreferredView = async (
  { rootState, state, commit }: SafeAny,
  preferredView: PreferredView
) => {
  const url = `${rootState.env?.requestUrl.events}/user`;
  const previousPreferredView = state.preferredView;

  commit('setPreferredView', preferredView);

  try {
    const { data } = await axiosInstance.patch<{ preferredView?: PreferredView }>(url, {
      preferredView
    });

    commit('setPreferredView', data.preferredView);
  } catch (error: SafeAny) {
    commit('setPreferredView', previousPreferredView);

    commit(
      'addNotification',
      {
        i18nTitle: 'errorUpdateUser',
        type: NotificationTypes.Error,
        i18nDescription: error.message
      },
      { root: true }
    );
  }
};
